import { LocalizationKeys, type LocalizationKey } from '../../i18n/keys'

/**
 * Region enum - основные регионы/страны
 */
export enum Region {
  UNSPECIFIED = 0,
  AFGHANISTAN = 1,
  ALBANIA = 2,
  ALGERIA = 3,
  ANDORRA = 4,
  ANGOLA = 5,
  ANTIGUA_AND_BARBUDA = 6,
  ARGENTINA = 7,
  AUSTRALIA = 8,
  AUSTRIA = 9,
  BAHAMAS = 10,
  BAHRAIN = 11,
  BANGLADESH = 12,
  BARBADOS = 13,
  BELARUS = 14,
  BELGIUM = 15,
  BELIZE = 16,
  BENIN = 17,
  BHUTAN = 18,
  BOLIVIA = 19,
  BOSNIA_AND_HERZEGOVINA = 20,
  BOTSWANA = 21,
  BRAZIL = 22,
  BRUNEI = 23,
  BULGARIA = 24,
  BURKINA_FASO = 25,
  BURUNDI = 26,
  CAMBODIA = 27,
  CAMEROON = 28,
  CANADA = 29,
  CAPE_VERDE = 30,
  CENTRAL_AFRICAN_REPUBLIC = 31,
  CHAD = 32,
  CHILE = 33,
  CHINA = 34,
  COLOMBIA = 35,
  COMOROS = 36,
  CONGO = 37,
  CONGO_DEMOCRATIC_REPUBLIC = 38,
  COSTA_RICA = 39,
  CROATIA = 40,
  CUBA = 41,
  CYPRUS = 42,
  CZECH_REPUBLIC = 43,
  DENMARK = 44,
  DJIBOUTI = 45,
  DOMINICA = 46,
  DOMINICAN_REPUBLIC = 47,
  ECUADOR = 48,
  EGYPT = 49,
  EL_SALVADOR = 50,
  EQUATORIAL_GUINEA = 51,
  ERITREA = 52,
  ESTONIA = 53,
  ESWATINI = 54,
  ETHIOPIA = 55,
  FIJI = 56,
  FINLAND = 57,
  FRANCE = 58,
  GABON = 59,
  GAMBIA = 60,
  GERMANY = 61,
  GHANA = 62,
  GREECE = 63,
  GRENADA = 64,
  GUATEMALA = 65,
  GUINEA = 66,
  GUINEA_BISSAU = 67,
  GUYANA = 68,
  HAITI = 69,
  HONDURAS = 70,
  HONG_KONG = 71,
  HUNGARY = 72,
  ICELAND = 73,
  INDIA = 74,
  INDONESIA = 75,
  IRAN = 76,
  IRAQ = 77,
  IRELAND = 78,
  ISRAEL = 79,
  ITALY = 80,
  IVORY_COAST = 81,
  JAMAICA = 82,
  JAPAN = 83,
  JORDAN = 84,
  KAZAKHSTAN = 85,
  KENYA = 86,
  KIRIBATI = 87,
  KOSOVO = 88,
  KUWAIT = 89,
  KYRGYZSTAN = 90,
  LAOS = 91,
  LATVIA = 92,
  LEBANON = 93,
  LESOTHO = 94,
  LIBERIA = 95,
  LIBYA = 96,
  LIECHTENSTEIN = 97,
  LITHUANIA = 98,
  LUXEMBOURG = 99,
  MACAU = 100,
  MADAGASCAR = 101,
  MALAWI = 102,
  MALAYSIA = 103,
  MALDIVES = 104,
  MALI = 105,
  MALTA = 106,
  MARSHALL_ISLANDS = 107,
  MAURITANIA = 108,
  MAURITIUS = 109,
  MEXICO = 110,
  MICRONESIA = 111,
  MOLDOVA = 112,
  MONACO = 113,
  MONGOLIA = 114,
  MONTENEGRO = 115,
  MOROCCO = 116,
  MOZAMBIQUE = 117,
  MYANMAR = 118,
  NAMIBIA = 119,
  NAURU = 120,
  NEPAL = 121,
  NETHERLANDS = 122,
  NEW_ZEALAND = 123,
  NICARAGUA = 124,
  NIGER = 125,
  NIGERIA = 126,
  NORTH_KOREA = 127,
  NORTH_MACEDONIA = 128,
  NORWAY = 129,
  OMAN = 130,
  PAKISTAN = 131,
  PALAU = 132,
  PALESTINE = 133,
  PANAMA = 134,
  PAPUA_NEW_GUINEA = 135,
  PARAGUAY = 136,
  PERU = 137,
  PHILIPPINES = 138,
  POLAND = 139,
  PORTUGAL = 140,
  QATAR = 141,
  ROMANIA = 142,
  RUSSIA = 143,
  RWANDA = 144,
  SAINT_KITTS_AND_NEVIS = 145,
  SAINT_LUCIA = 146,
  SAINT_VINCENT_AND_THE_GRENADINES = 147,
  SAMOA = 148,
  SAN_MARINO = 149,
  SAO_TOME_AND_PRINCIPE = 150,
  SAUDI_ARABIA = 151,
  SENEGAL = 152,
  SERBIA = 153,
  SEYCHELLES = 154,
  SIERRA_LEONE = 155,
  SINGAPORE = 156,
  SLOVAKIA = 157,
  SLOVENIA = 158,
  SOLOMON_ISLANDS = 159,
  SOMALIA = 160,
  SOUTH_AFRICA = 161,
  SOUTH_KOREA = 162,
  SOUTH_SUDAN = 163,
  SPAIN = 164,
  SRI_LANKA = 165,
  SUDAN = 166,
  SURINAME = 167,
  SWEDEN = 168,
  SWITZERLAND = 169,
  SYRIA = 170,
  TAIWAN = 171,
  TAJIKISTAN = 172,
  TANZANIA = 173,
  THAILAND = 174,
  TIMOR_LESTE = 175,
  TOGO = 176,
  TONGA = 177,
  TRINIDAD_AND_TOBAGO = 178,
  TUNISIA = 179,
  TURKEY = 180,
  TURKMENISTAN = 181,
  TUVALU = 182,
  UGANDA = 183,
  UKRAINE = 184,
  UNITED_ARAB_EMIRATES = 185,
  UNITED_KINGDOM = 186,
  UNITED_STATES = 187,
  URUGUAY = 188,
  UZBEKISTAN = 189,
  VANUATU = 190,
  VENEZUELA = 191,
  VIETNAM = 192,
  YEMEN = 193,
  ZAMBIA = 194,
  ZIMBABWE = 195,
}

/**
 * Мапинг Region enum на ключи локализации
 */
export const REGION_I18N_KEYS: Record<Region, LocalizationKey> = {
  [Region.UNSPECIFIED]: LocalizationKeys.REGION_UNSPECIFIED,
  [Region.AFGHANISTAN]: LocalizationKeys.REGION_AFGHANISTAN,
  [Region.ALBANIA]: LocalizationKeys.REGION_ALBANIA,
  [Region.ALGERIA]: LocalizationKeys.REGION_ALGERIA,
  [Region.ANDORRA]: LocalizationKeys.REGION_ANDORRA,
  [Region.ANGOLA]: LocalizationKeys.REGION_ANGOLA,
  [Region.ANTIGUA_AND_BARBUDA]: LocalizationKeys.REGION_ANTIGUA_AND_BARBUDA,
  [Region.ARGENTINA]: LocalizationKeys.REGION_ARGENTINA,
  [Region.AUSTRALIA]: LocalizationKeys.REGION_AUSTRALIA,
  [Region.AUSTRIA]: LocalizationKeys.REGION_AUSTRIA,
  [Region.BAHAMAS]: LocalizationKeys.REGION_BAHAMAS,
  [Region.BAHRAIN]: LocalizationKeys.REGION_BAHRAIN,
  [Region.BANGLADESH]: LocalizationKeys.REGION_BANGLADESH,
  [Region.BARBADOS]: LocalizationKeys.REGION_BARBADOS,
  [Region.BELARUS]: LocalizationKeys.REGION_BELARUS,
  [Region.BELGIUM]: LocalizationKeys.REGION_BELGIUM,
  [Region.BELIZE]: LocalizationKeys.REGION_BELIZE,
  [Region.BENIN]: LocalizationKeys.REGION_BENIN,
  [Region.BHUTAN]: LocalizationKeys.REGION_BHUTAN,
  [Region.BOLIVIA]: LocalizationKeys.REGION_BOLIVIA,
  [Region.BOSNIA_AND_HERZEGOVINA]: LocalizationKeys.REGION_BOSNIA_AND_HERZEGOVINA,
  [Region.BOTSWANA]: LocalizationKeys.REGION_BOTSWANA,
  [Region.BRAZIL]: LocalizationKeys.REGION_BRAZIL,
  [Region.BRUNEI]: LocalizationKeys.REGION_BRUNEI,
  [Region.BULGARIA]: LocalizationKeys.REGION_BULGARIA,
  [Region.BURKINA_FASO]: LocalizationKeys.REGION_BURKINA_FASO,
  [Region.BURUNDI]: LocalizationKeys.REGION_BURUNDI,
  [Region.CAMBODIA]: LocalizationKeys.REGION_CAMBODIA,
  [Region.CAMEROON]: LocalizationKeys.REGION_CAMEROON,
  [Region.CANADA]: LocalizationKeys.REGION_CANADA,
  [Region.CAPE_VERDE]: LocalizationKeys.REGION_CAPE_VERDE,
  [Region.CENTRAL_AFRICAN_REPUBLIC]: LocalizationKeys.REGION_CENTRAL_AFRICAN_REPUBLIC,
  [Region.CHAD]: LocalizationKeys.REGION_CHAD,
  [Region.CHILE]: LocalizationKeys.REGION_CHILE,
  [Region.CHINA]: LocalizationKeys.REGION_CHINA,
  [Region.COLOMBIA]: LocalizationKeys.REGION_COLOMBIA,
  [Region.COMOROS]: LocalizationKeys.REGION_COMOROS,
  [Region.CONGO]: LocalizationKeys.REGION_CONGO,
  [Region.CONGO_DEMOCRATIC_REPUBLIC]: LocalizationKeys.REGION_CONGO_DEMOCRATIC_REPUBLIC,
  [Region.COSTA_RICA]: LocalizationKeys.REGION_COSTA_RICA,
  [Region.CROATIA]: LocalizationKeys.REGION_CROATIA,
  [Region.CUBA]: LocalizationKeys.REGION_CUBA,
  [Region.CYPRUS]: LocalizationKeys.REGION_CYPRUS,
  [Region.CZECH_REPUBLIC]: LocalizationKeys.REGION_CZECH_REPUBLIC,
  [Region.DENMARK]: LocalizationKeys.REGION_DENMARK,
  [Region.DJIBOUTI]: LocalizationKeys.REGION_DJIBOUTI,
  [Region.DOMINICA]: LocalizationKeys.REGION_DOMINICA,
  [Region.DOMINICAN_REPUBLIC]: LocalizationKeys.REGION_DOMINICAN_REPUBLIC,
  [Region.ECUADOR]: LocalizationKeys.REGION_ECUADOR,
  [Region.EGYPT]: LocalizationKeys.REGION_EGYPT,
  [Region.EL_SALVADOR]: LocalizationKeys.REGION_EL_SALVADOR,
  [Region.EQUATORIAL_GUINEA]: LocalizationKeys.REGION_EQUATORIAL_GUINEA,
  [Region.ERITREA]: LocalizationKeys.REGION_ERITREA,
  [Region.ESTONIA]: LocalizationKeys.REGION_ESTONIA,
  [Region.ESWATINI]: LocalizationKeys.REGION_ESWATINI,
  [Region.ETHIOPIA]: LocalizationKeys.REGION_ETHIOPIA,
  [Region.FIJI]: LocalizationKeys.REGION_FIJI,
  [Region.FINLAND]: LocalizationKeys.REGION_FINLAND,
  [Region.FRANCE]: LocalizationKeys.REGION_FRANCE,
  [Region.GABON]: LocalizationKeys.REGION_GABON,
  [Region.GAMBIA]: LocalizationKeys.REGION_GAMBIA,
  [Region.GERMANY]: LocalizationKeys.REGION_GERMANY,
  [Region.GHANA]: LocalizationKeys.REGION_GHANA,
  [Region.GREECE]: LocalizationKeys.REGION_GREECE,
  [Region.GRENADA]: LocalizationKeys.REGION_GRENADA,
  [Region.GUATEMALA]: LocalizationKeys.REGION_GUATEMALA,
  [Region.GUINEA]: LocalizationKeys.REGION_GUINEA,
  [Region.GUINEA_BISSAU]: LocalizationKeys.REGION_GUINEA_BISSAU,
  [Region.GUYANA]: LocalizationKeys.REGION_GUYANA,
  [Region.HAITI]: LocalizationKeys.REGION_HAITI,
  [Region.HONDURAS]: LocalizationKeys.REGION_HONDURAS,
  [Region.HONG_KONG]: LocalizationKeys.REGION_HONG_KONG,
  [Region.HUNGARY]: LocalizationKeys.REGION_HUNGARY,
  [Region.ICELAND]: LocalizationKeys.REGION_ICELAND,
  [Region.INDIA]: LocalizationKeys.REGION_INDIA,
  [Region.INDONESIA]: LocalizationKeys.REGION_INDONESIA,
  [Region.IRAN]: LocalizationKeys.REGION_IRAN,
  [Region.IRAQ]: LocalizationKeys.REGION_IRAQ,
  [Region.IRELAND]: LocalizationKeys.REGION_IRELAND,
  [Region.ISRAEL]: LocalizationKeys.REGION_ISRAEL,
  [Region.ITALY]: LocalizationKeys.REGION_ITALY,
  [Region.IVORY_COAST]: LocalizationKeys.REGION_IVORY_COAST,
  [Region.JAMAICA]: LocalizationKeys.REGION_JAMAICA,
  [Region.JAPAN]: LocalizationKeys.REGION_JAPAN,
  [Region.JORDAN]: LocalizationKeys.REGION_JORDAN,
  [Region.KAZAKHSTAN]: LocalizationKeys.REGION_KAZAKHSTAN,
  [Region.KENYA]: LocalizationKeys.REGION_KENYA,
  [Region.KIRIBATI]: LocalizationKeys.REGION_KIRIBATI,
  [Region.KOSOVO]: LocalizationKeys.REGION_KOSOVO,
  [Region.KUWAIT]: LocalizationKeys.REGION_KUWAIT,
  [Region.KYRGYZSTAN]: LocalizationKeys.REGION_KYRGYZSTAN,
  [Region.LAOS]: LocalizationKeys.REGION_LAOS,
  [Region.LATVIA]: LocalizationKeys.REGION_LATVIA,
  [Region.LEBANON]: LocalizationKeys.REGION_LEBANON,
  [Region.LESOTHO]: LocalizationKeys.REGION_LESOTHO,
  [Region.LIBERIA]: LocalizationKeys.REGION_LIBERIA,
  [Region.LIBYA]: LocalizationKeys.REGION_LIBYA,
  [Region.LIECHTENSTEIN]: LocalizationKeys.REGION_LIECHTENSTEIN,
  [Region.LITHUANIA]: LocalizationKeys.REGION_LITHUANIA,
  [Region.LUXEMBOURG]: LocalizationKeys.REGION_LUXEMBOURG,
  [Region.MACAU]: LocalizationKeys.REGION_MACAU,
  [Region.MADAGASCAR]: LocalizationKeys.REGION_MADAGASCAR,
  [Region.MALAWI]: LocalizationKeys.REGION_MALAWI,
  [Region.MALAYSIA]: LocalizationKeys.REGION_MALAYSIA,
  [Region.MALDIVES]: LocalizationKeys.REGION_MALDIVES,
  [Region.MALI]: LocalizationKeys.REGION_MALI,
  [Region.MALTA]: LocalizationKeys.REGION_MALTA,
  [Region.MARSHALL_ISLANDS]: LocalizationKeys.REGION_MARSHALL_ISLANDS,
  [Region.MAURITANIA]: LocalizationKeys.REGION_MAURITANIA,
  [Region.MAURITIUS]: LocalizationKeys.REGION_MAURITIUS,
  [Region.MEXICO]: LocalizationKeys.REGION_MEXICO,
  [Region.MICRONESIA]: LocalizationKeys.REGION_MICRONESIA,
  [Region.MOLDOVA]: LocalizationKeys.REGION_MOLDOVA,
  [Region.MONACO]: LocalizationKeys.REGION_MONACO,
  [Region.MONGOLIA]: LocalizationKeys.REGION_MONGOLIA,
  [Region.MONTENEGRO]: LocalizationKeys.REGION_MONTENEGRO,
  [Region.MOROCCO]: LocalizationKeys.REGION_MOROCCO,
  [Region.MOZAMBIQUE]: LocalizationKeys.REGION_MOZAMBIQUE,
  [Region.MYANMAR]: LocalizationKeys.REGION_MYANMAR,
  [Region.NAMIBIA]: LocalizationKeys.REGION_NAMIBIA,
  [Region.NAURU]: LocalizationKeys.REGION_NAURU,
  [Region.NEPAL]: LocalizationKeys.REGION_NEPAL,
  [Region.NETHERLANDS]: LocalizationKeys.REGION_NETHERLANDS,
  [Region.NEW_ZEALAND]: LocalizationKeys.REGION_NEW_ZEALAND,
  [Region.NICARAGUA]: LocalizationKeys.REGION_NICARAGUA,
  [Region.NIGER]: LocalizationKeys.REGION_NIGER,
  [Region.NIGERIA]: LocalizationKeys.REGION_NIGERIA,
  [Region.NORTH_KOREA]: LocalizationKeys.REGION_NORTH_KOREA,
  [Region.NORTH_MACEDONIA]: LocalizationKeys.REGION_NORTH_MACEDONIA,
  [Region.NORWAY]: LocalizationKeys.REGION_NORWAY,
  [Region.OMAN]: LocalizationKeys.REGION_OMAN,
  [Region.PAKISTAN]: LocalizationKeys.REGION_PAKISTAN,
  [Region.PALAU]: LocalizationKeys.REGION_PALAU,
  [Region.PALESTINE]: LocalizationKeys.REGION_PALESTINE,
  [Region.PANAMA]: LocalizationKeys.REGION_PANAMA,
  [Region.PAPUA_NEW_GUINEA]: LocalizationKeys.REGION_PAPUA_NEW_GUINEA,
  [Region.PARAGUAY]: LocalizationKeys.REGION_PARAGUAY,
  [Region.PERU]: LocalizationKeys.REGION_PERU,
  [Region.PHILIPPINES]: LocalizationKeys.REGION_PHILIPPINES,
  [Region.POLAND]: LocalizationKeys.REGION_POLAND,
  [Region.PORTUGAL]: LocalizationKeys.REGION_PORTUGAL,
  [Region.QATAR]: LocalizationKeys.REGION_QATAR,
  [Region.ROMANIA]: LocalizationKeys.REGION_ROMANIA,
  [Region.RUSSIA]: LocalizationKeys.REGION_RUSSIA,
  [Region.RWANDA]: LocalizationKeys.REGION_RWANDA,
  [Region.SAINT_KITTS_AND_NEVIS]: LocalizationKeys.REGION_SAINT_KITTS_AND_NEVIS,
  [Region.SAINT_LUCIA]: LocalizationKeys.REGION_SAINT_LUCIA,
  [Region.SAINT_VINCENT_AND_THE_GRENADINES]: LocalizationKeys.REGION_SAINT_VINCENT_AND_THE_GRENADINES,
  [Region.SAMOA]: LocalizationKeys.REGION_SAMOA,
  [Region.SAN_MARINO]: LocalizationKeys.REGION_SAN_MARINO,
  [Region.SAO_TOME_AND_PRINCIPE]: LocalizationKeys.REGION_SAO_TOME_AND_PRINCIPE,
  [Region.SAUDI_ARABIA]: LocalizationKeys.REGION_SAUDI_ARABIA,
  [Region.SENEGAL]: LocalizationKeys.REGION_SENEGAL,
  [Region.SERBIA]: LocalizationKeys.REGION_SERBIA,
  [Region.SEYCHELLES]: LocalizationKeys.REGION_SEYCHELLES,
  [Region.SIERRA_LEONE]: LocalizationKeys.REGION_SIERRA_LEONE,
  [Region.SINGAPORE]: LocalizationKeys.REGION_SINGAPORE,
  [Region.SLOVAKIA]: LocalizationKeys.REGION_SLOVAKIA,
  [Region.SLOVENIA]: LocalizationKeys.REGION_SLOVENIA,
  [Region.SOLOMON_ISLANDS]: LocalizationKeys.REGION_SOLOMON_ISLANDS,
  [Region.SOMALIA]: LocalizationKeys.REGION_SOMALIA,
  [Region.SOUTH_AFRICA]: LocalizationKeys.REGION_SOUTH_AFRICA,
  [Region.SOUTH_KOREA]: LocalizationKeys.REGION_SOUTH_KOREA,
  [Region.SOUTH_SUDAN]: LocalizationKeys.REGION_SOUTH_SUDAN,
  [Region.SPAIN]: LocalizationKeys.REGION_SPAIN,
  [Region.SRI_LANKA]: LocalizationKeys.REGION_SRI_LANKA,
  [Region.SUDAN]: LocalizationKeys.REGION_SUDAN,
  [Region.SURINAME]: LocalizationKeys.REGION_SURINAME,
  [Region.SWEDEN]: LocalizationKeys.REGION_SWEDEN,
  [Region.SWITZERLAND]: LocalizationKeys.REGION_SWITZERLAND,
  [Region.SYRIA]: LocalizationKeys.REGION_SYRIA,
  [Region.TAIWAN]: LocalizationKeys.REGION_TAIWAN,
  [Region.TAJIKISTAN]: LocalizationKeys.REGION_TAJIKISTAN,
  [Region.TANZANIA]: LocalizationKeys.REGION_TANZANIA,
  [Region.THAILAND]: LocalizationKeys.REGION_THAILAND,
  [Region.TIMOR_LESTE]: LocalizationKeys.REGION_TIMOR_LESTE,
  [Region.TOGO]: LocalizationKeys.REGION_TOGO,
  [Region.TONGA]: LocalizationKeys.REGION_TONGA,
  [Region.TRINIDAD_AND_TOBAGO]: LocalizationKeys.REGION_TRINIDAD_AND_TOBAGO,
  [Region.TUNISIA]: LocalizationKeys.REGION_TUNISIA,
  [Region.TURKEY]: LocalizationKeys.REGION_TURKEY,
  [Region.TURKMENISTAN]: LocalizationKeys.REGION_TURKMENISTAN,
  [Region.TUVALU]: LocalizationKeys.REGION_TUVALU,
  [Region.UGANDA]: LocalizationKeys.REGION_UGANDA,
  [Region.UKRAINE]: LocalizationKeys.REGION_UKRAINE,
  [Region.UNITED_ARAB_EMIRATES]: LocalizationKeys.REGION_UNITED_ARAB_EMIRATES,
  [Region.UNITED_KINGDOM]: LocalizationKeys.REGION_UNITED_KINGDOM,
  [Region.UNITED_STATES]: LocalizationKeys.REGION_UNITED_STATES,
  [Region.URUGUAY]: LocalizationKeys.REGION_URUGUAY,
  [Region.UZBEKISTAN]: LocalizationKeys.REGION_UZBEKISTAN,
  [Region.VANUATU]: LocalizationKeys.REGION_VANUATU,
  [Region.VENEZUELA]: LocalizationKeys.REGION_VENEZUELA,
  [Region.VIETNAM]: LocalizationKeys.REGION_VIETNAM,
  [Region.YEMEN]: LocalizationKeys.REGION_YEMEN,
  [Region.ZAMBIA]: LocalizationKeys.REGION_ZAMBIA,
  [Region.ZIMBABWE]: LocalizationKeys.REGION_ZIMBABWE,
} as const
